export default function (a, b) { return a.filter(value => b.includes(value)).length > 0; }
